module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-magnify")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("An investigation")]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.president.name) + " investigated " + _vm._s(_vm.target.name))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de71a296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/events/events/investigation/preview.vue
// module id = 354
// module chunks = 0